// extracted by mini-css-extract-plugin
module.exports = {"singleCharacteristics":"CharacteristicsItem_singleCharacteristics__gR_OW","singleCharacteristics__top":"CharacteristicsItem_singleCharacteristics__top____K6g"};